import { render } from "./AdminPrefeituraDashboard.vue?vue&type=template&id=1767aed4&scoped=true"
import script from "./AdminPrefeituraDashboard.vue?vue&type=script&lang=js"
export * from "./AdminPrefeituraDashboard.vue?vue&type=script&lang=js"

import "./AdminPrefeituraDashboard.vue?vue&type=style&index=0&id=1767aed4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1767aed4"]])

export default __exports__